import React from 'react'
import { Card, CardContent, Divider, Grid, Table, TableBody, TableRow, TableContainer } from '@material-ui/core'
import TableBodyCell from 'components/table/TableBodyCell';
import { BootstrapBadge } from 'components/ui/BootstrapBadge';
import KisshtLink from 'components/ui/KisshtLink';
import { RobotFont } from 'components/ui/RobotFont';
import { CustomTableWrapper } from 'shared/components/CustomTableWrapper';
import { ROUTES_VAR, ROUTE_NAME,PERMISSIONS } from 'shared/constants';
import { readableFormatDate } from 'shared/utils';

export default function Refund(props) {
  const { data } = props;
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item>
            Refund Details
        </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        {data && data.length > 0 && data.map((item) => {
          const { refund_reference_number, amount, pg_refund_reference_number, refunded_at, refunded_by_subuser, status } = item;
          return <CustomTableWrapper>
            <Grid item xs={12}>
            <TableContainer className="common_X_scroll">
              <Table>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Refund Reference Number</TableBodyCell>
                    <TableBodyCell className="common_table_title">Amount</TableBodyCell>
                    <TableBodyCell className="common_table_title">status</TableBodyCell>
                    <TableBodyCell className="common_table_title">Refunded At</TableBodyCell>
                    <TableBodyCell className="common_table_title">Refunded By Subuser</TableBodyCell>
                    <TableBodyCell className="common_table_title">PG Refund Reference Number</TableBodyCell>
                  </TableRow>
                </TableBody>

                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_content min_width_snapshot">
                      <KisshtLink
                        to={`${ROUTES_VAR.refund}/${refund_reference_number}`}
                        permission={PERMISSIONS.payment.refund_view}
                        route={ROUTE_NAME.payment}
                      >
                        {refund_reference_number}
                      </KisshtLink>
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content min_width_snapshot">
                      <RobotFont type="medium">₹</RobotFont>
                      {amount}
                    </TableBodyCell>
                    <TableBodyCell >
                      {" "}
                      <BootstrapBadge text={status} />
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content min_width_snapshot">
                      {readableFormatDate(refunded_at)}

                    </TableBodyCell>
                    <TableBodyCell className="common_table_content min_width_snapshot">{refunded_by_subuser}</TableBodyCell>
                    <TableBodyCell className="common_table_content min_width_snapshot">
                      {pg_refund_reference_number}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
              </Table>
              </TableContainer>  
            </Grid>
          </CustomTableWrapper>
        })}

      </CardContent>
    </Card>
  )
}
